export var InternalEventPublishStrategy;
(function (InternalEventPublishStrategy) {
    InternalEventPublishStrategy["ASYNC"] = "ASYNC";
    InternalEventPublishStrategy["SEQUENCE"] = "SEQUENCE";
})(InternalEventPublishStrategy || (InternalEventPublishStrategy = {}));
